<template>
  <v-menu rounded bottom offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text dark v-on="on">
        <v-icon dark>mdi-cog</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item v-for="item in items" :key="item.title" @click="onClickListItem(item)">
          <v-icon left>{{ item.icon }}</v-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import { signout } from '@/libs/common';
import { createSecurityLog } from '@/libs/v1/api/client';

const CONNECTED_PORTAL_URL = process.env.VUE_APP_CONNECTED_PORTAL;

interface ListItem {
  title: string;
  icon: string;
  to: string;
  option?: number;
}

@Component
export default class SettingsMenu extends Vue {
  get email(): string {
    return Store.getters.email;
  }

  get spaceSettingAuthority(): boolean {
    return Store.getters.spaceSettingAuthority;
  }

  get userControlAuthority(): boolean {
    return Store.getters.userControlAuthority;
  }

  get couponAuthority(): boolean {
    return Store.getters.couponAuthority;
  }

  get items(): ListItem[] {
    return [
      { title: 'メールアドレス変更', icon: 'mdi-email', to: '/dashboard/change/email' },
      { title: 'パスワード変更', icon: 'mdi-lock', to: '/dashboard/change/password' },
      { title: '通知設定', icon: 'mdi-bell', to: '/dashboard/notification' },
      ...(this.couponAuthority
        ? [{ title: 'クーポン管理', icon: 'mdi-ticket-percent-outline', to: '/dashboard/coupon/control' }]
        : []),
      ...(this.userControlAuthority
        ? [{ title: 'ユーザー管理', icon: 'mdi-account-circle', to: '/dashboard/user/control' }]
        : []),
      ...(this.spaceSettingAuthority
        ? [
            { title: '事業所管理', icon: 'mdi-office-building', to: '/dashboard/office/management' },
            { title: '事業所登録', icon: 'mdi-google-classroom', to: '/dashboard/office/register' },
          ]
        : []),
      { title: 'Connected Portal', icon: 'mdi-earth', to: CONNECTED_PORTAL_URL, option: 1 },
      { title: 'ログアウト', icon: 'mdi-logout', to: '/dashboard/login', option: 0 },
    ];
  }

  private async onClickListItem(item: ListItem) {
    const { to, option } = item;
    switch (option) {
      case 0:
        await signout();
        await createSecurityLog({ action: 'Logout', userName: this.email });
        this.$router.push(to);
        break;
      case 1:
        window.open(to, '_blank');
        break;
      default:
        this.$router.push(to).catch((_e) => {});
        break;
    }
  }
}
</script>
